import * as XLSX from 'xlsx'

export async function onFileChange(event, context) {
  const file = event.target.files[0]
  if (!file) return

  context.loading = true
  try {
    const reader = new FileReader()
    reader.onload = async (e) => {
      const data = e.target.result
      const workbook = XLSX.read(data, { 
        type: 'binary', 
        cellText: true, 
        cellDates: true, 
        dateNF: 'yyyy-mm-dd;@', 
        WTF: 'utc' 
      })
      const sheetName = workbook.SheetNames[0]
      const sheet = workbook.Sheets[sheetName]
      const jsonData = XLSX.utils.sheet_to_json(sheet, { dateNF: 'yyyy-mm-dd;@' })

      // Map Excel headers to schema attributes
      const mappedData = jsonData.map(row => ({
        date: new Date(row.date.getTime() + 24 * 60 * 60 * 1000),
        tourship: row.tourship,
        cruiseline: row.cruiseline,
        tourcode: row.tourcode,
        mxpcode: row.mxpcode,
        tourname: row.tourname,
        maxcapacity: row.maxcapacity,
        totalsold: row.totalsold,
        fromtime: row.fromtime,
        totime: row.totime,
        todaydate: row.sent_on,
        status: row.status
      }))

      for (const row of mappedData) {
        await context.$xhr.post('/api/oceans', { data: row })
      }

      await Promise.all([context.fetchTours(), context.fetchAllDataForFilters()])
      context.showImportModal = false
    }
    reader.readAsBinaryString(file)
  } catch (error) {
    console.error('Error importing file:', error)
    context.$bvToast.toast('Failed to import file. Please try again.', { variant: 'danger', solid: true })
  } finally {
    context.loading = false
  }
}